import { useEffect, useContext, useState, useRef } from "react";
import WMTS from "./services/wmts";
import DXF from "./services/dxf";
import WMS from "./services/wms";
import ShapeFile from "./services/shapefile";
import KML from "./services/kml";
import GPX from "./services/gpx";
import WFS from "./services/wfs";
import GEOJSONFILE from "./services/geoJSON";
import CSW from "./services/csw";
import { trans } from "../../lib/utils";

function AddServicePanel(props) {
  const [content, setContent] = useState(null);
  const [showBack, setBack] = useState(false);
  const [selectedService, setSelectedService] = useState(null);

  useEffect(() => {
    setContent(selectService());
  }, []);

  const onClickService = (service) => {
    switch (service) {
      case "wms":
        setContent(<WMS></WMS>);
        setSelectedService(trans("Add WMS"));
        break;
      case "wmts":
        setContent(<WMTS></WMTS>);
        setSelectedService(trans("Add WMTS"));
        break;
      case "wfs":
        setContent(<WFS></WFS>);
        setSelectedService(trans("Add WFS"));
        break;
      case "shapefile":
        setContent(<ShapeFile></ShapeFile>);
        setSelectedService(trans("Upload Shapefile"));
        break;
      case "dxf":
        setContent(<DXF></DXF>);
        setSelectedService(trans("Upload DXF file"));
        break;
      case "kml":
        setContent(<KML></KML>);
        setSelectedService(trans("Upload KML file"));
        break;
      case "gpx":
        setContent(<GPX />);
        setSelectedService(trans("Upload GPF file"));
        break;
      case "geojson":
        setContent(<GEOJSONFILE />);
        setSelectedService(trans("Upload GeoJSON file"));
        break;
      case "csw":
        setContent(<CSW />);
        setSelectedService(trans("Add CSW"));
        break;
    }
    setBack(true);
  };

  const avaiblableServices = [
    { label: "WMS", value: "wms" },
    { label: "WFS", value: "wfs" },
    { label: "WMTS", value: "wmts" },
    { label: "Shapefile", value: "shapefile" },
    { label: "KML", value: "kml" },
    { label: "GeoJSON", value: "geojson" },
    { label: "DXF", value: "dxf" },
    { label: "GPX", value: "gpx" },
    { label: "CSW", value: "csw" },
  ];

  const selectService = () => {
    return (
      <div className="row mt-3">
        {avaiblableServices.map((el) => {
          return (
            <div className="col-4">
              <div
                className="card m-1 "
                style={{ minHeight: "120px" }}
                role="button"
                onClick={() => {
                  onClickService(el.value);
                }}
              >
                <div className="card-body align-items-center d-flex justify-content-center add-service-boxes rounded">
                  <div className="text-center h-100">
                    <div className="m-auto h5"> {el.label}</div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="pe-3 ps-3">
      <div className="mt-3 mb-1">
        {showBack ? (
          <span
            role="button"
            className="small"
            onClick={() => {
              setContent(selectService());
              setBack(false);
              setSelectedService(null);
            }}
          >
            <i className="fas fa-chevron-left me-1 small"></i>
            {trans("Back")}
          </span>
        ) : (
          ""
        )}
      </div>
      <div className="mb-2">
        <label className="color-get-blue strong ">
          <strong>{selectedService}</strong>
        </label>
      </div>
      {content}
    </div>
  );
}
export default AddServicePanel;
